import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CheckCircle } from 'lucide-react';

const AboutPage = () => {
  const missionPoints = [
    'Provide our clients thoughtful counsel and relentless advocacy.',
    'Provide products and services designed to meet client needs while maintaining a strong focus on trust and client relationships.',
    'Commitment to the free agency of our team to represent our clients best interests.',
    'Commitment to the community.',
  ];

  const rankings = [
    'Each member of our agency and our advisory board has attained excellence and expertise in their field.',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Banner */}
      <div className="page-banner">
        <div className="container-wide">
          <h1>ABOUT US</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link> &gt; About Us
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="content-section" data-testid="about-content">
        <div className="container-narrow">
          
          {/* About */}
          <h2>About Us</h2>
          <p>
            Insurance agencies are full of salespeople. That's a fact. We're different. We are seasoned operators and business advisors who first built our expertise in other industries, before attaining expertise with insurance. We're not here to sell you a product. We're here to function as an integral part of the business: close enough to understand the operation, accountable for the protection around it.
          </p>
          <p>
            Every recommendation is specific to the way your company works, not pulled from a menu. Our incentives follow the success of our relationship to a client, not a carrier bonus or quota. We care about the right decision — the structure, the protection, and the total outcome.
          </p>
          <p>
            Most firms talk about real-world experience. We brought it in with us, along with powerful networks of relationships gained over time, which we can leverage should your needs demand it.
          </p>
          <p>
            If you want a policy, almost anyone can help. If you want a partner with solutions that fit and grow your business, AIR is built for that.
          </p>

          <hr className="content-divider" />

          {/* Mission Statement */}
          <h2>Mission Statement</h2>
          <ul className="mission-list">
            {missionPoints.map((point, index) => (
              <li key={index}>
                <CheckCircle className="mission-check" />
                <span>{point}</span>
              </li>
            ))}
          </ul>

          <hr className="content-divider" />

          {/* Rankings */}
          <h2>Recognition</h2>
          <ul className="mission-list">
            {rankings.map((point, index) => (
              <li key={index}>
                <CheckCircle className="mission-check" />
                <span>{point}</span>
              </li>
            ))}
          </ul>

          <hr className="content-divider" />

          {/* In the Community */}
          <h2>In the Community</h2>
          <p>
            At Archon Insurance, we believe in giving back to the Massachusetts communities 
            we serve. Our team actively participates in local charitable initiatives, 
            supports small business development programs, and sponsors community events 
            throughout the Commonwealth.
          </p>
          <p>
            We regularly support local food banks, participate in community clean-up events, 
            and provide educational workshops on risk management for local business owners. 
            Our commitment to community extends beyond insurance—it's part of who we are.
          </p>

          <hr className="content-divider" />

          {/* CTA */}
          <div className="text-center py-8">
            <Link to="/claims" className="btn-navy">
              File a Claim
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
